import { CommodityWithType, MetadataService, PhysicalUnitWithType } from '@eadsysteme/billingclient-v1';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { SessionService } from '../session.service';

@Injectable({ providedIn: 'root' })
export class BillingMetaData {
	private readonly metaDataService = inject(MetadataService);
	private readonly sessionService = inject(SessionService);

	private readonly physicalUnits: WritableSignal<PhysicalUnitWithType[]> = signal(undefined);
	private readonly commodities: WritableSignal<CommodityWithType[]> = signal(undefined);

	loadMetadata() {
		this.metaDataService.getCommodities(this.sessionService.effectiveArea).subscribe((res) => {
			this.commodities.set(res);
		});
		this.metaDataService.getPhysicalUnits(this.sessionService.effectiveArea).subscribe((res) => {
			this.physicalUnits.set(res);
		});
	}

	getUnits(): PhysicalUnitWithType[] {
		if (this.physicalUnits()) {
			return this.physicalUnits();
		}
	}

	getCommodities(): CommodityWithType[] {
		if (this.commodities()) {
			return this.commodities();
		}
	}

	/** Manuelles Invalidieren/Refresh */
	clearCache() {
		this.physicalUnits.set(undefined);
		this.commodities.set(undefined);
	}
}
